// extracted by mini-css-extract-plugin
export default {"heroCanvas":"HeroCanvas_heroCanvas__2Qry+"};